import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentCrossx = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentCrossx
